import axios from 'axios';
import { STUDIO_API_URL } from '../config';

const studioAxios = axios.create({
    baseURL: STUDIO_API_URL,
})

export default studioAxios;